import type { IconSvgObject } from './types';

const LockedIcon: IconSvgObject = [
  ["path", { d: "M8 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V8M16 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V8M16 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V16M8 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.71429 11H8L8 17H16V11H14.2857M9.71429 11V9.22222C9.71429 7.99492 10.7376 7 12 7C13.2624 7 14.2857 7.99492 14.2857 9.22222V11M9.71429 11H14.2857", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LockedIcon;
